<template lang="html">
    <div class="content">
       <top></top>
        <router-view ></router-view>
        <my-footer></my-footer>
    </div>
</template>
<script>
    import top from './common/nav.vue'
    import myFooter from './common/footer.vue'
    export default {
        data: function() {
            return {

            }
        },
        components: {
            top,
            myFooter
        },
        created() {
            window.addEventListener('hashchange', () => {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            });
        },
        methods: {

        }
    }
</script>
<style lang="less" scoped>
    .content {
        /*background: #ECECEC*/
    }
</style>


// WEBPACK FOOTER //
// index.vue?89a26db4